import { CounterResponse } from './../shared/counter'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from './../../environment/environment'

@Injectable({
  providedIn: 'root'
})
export class CounterService {
  private api = `${environment.apiBase}/counter.php`

  constructor (private http: HttpClient) {
    console.log("api:" + this.api);
  }

  get (): Observable<CounterResponse> {
    return this.http.get<CounterResponse>(`${this.api}?action=get`)
  }

  increment (): Observable<CounterResponse> {
    return this.http.post<CounterResponse>(`${this.api}?action=increment`, {})
  }

  set (value: number): Observable<CounterResponse> {
    return this.http.post<CounterResponse>(`${this.api}?action=set`, { value })
  }
}
